import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CreditCardData } from 'design-system';

export const initialState: CreditCardData = {
  cardName: '',
  cardNumber: '',
  cardType: '',
  expirationDate: '',
  securityCode: '',
  bankEntityCode: '',
  cardAddress: '',
};

const creditCardDataSlice = createSlice({
  name: 'creditCardData',
  initialState,
  reducers: {
    updatePaymentData: (state, action: PayloadAction<CreditCardData>): void => {
      const {
        cardName,
        cardNumber,
        cardType,
        expirationDate,
        securityCode,
        bankEntityCode,
        cardAddress,
      } = action.payload;
      state.cardName = cardName;
      state.cardNumber = cardNumber;
      state.cardType = cardType;
      state.expirationDate = expirationDate;
      state.securityCode = securityCode;
      state.bankEntityCode = bankEntityCode;
      state.cardAddress = cardAddress;
    },
  },
});

export const { updatePaymentData } = creditCardDataSlice.actions;

export default creditCardDataSlice.reducer;
